import type { NextPage } from 'next';
import React from 'react';

import { Landing } from '../../components/Landing';

const IndexPage: NextPage = () => <Landing />;

export default IndexPage;
